import { useColors } from "../../hooks/colors/useColors";
import { useUser } from "../../hooks/react-query/useUser";
import { Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons";
import { useRouter } from "next/router";
import { QuickLinks } from "../../components/pages/user/page/QuickLinks";
import useAsyncEffect from "use-async-effect";
import { isPhone } from "../../constants/env";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { Fragment } from "react";
import { MyHead } from "../../components/pages/MyHead";
import dynamic from "next/dynamic";
import { Footer } from "../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

const UserHeader = dynamic(
  () =>
    import("./../../components/pages/user/page/UserHeader").then(
      (mod) => mod.UserHeader
    ),
  {
    ssr: false,
  }
);

function UserProfilePage() {
  const { colors } = useColors();
  const { user, userIsLoading } = useUser();
  const router = useRouter();
  const { t } = useTranslation("common");

  useAsyncEffect(async () => {
    if (!userIsLoading && !user) {
      await router.push("/");
    }
  }, [userIsLoading]);

  return (
    <Fragment>
      <MyHead title={t("profile")} description={t("profile")} />
      <UserHeader />
      {user && (
        <Fragment>
          <div
            style={{ backgroundColor: colors.background }}
            className="flex justify-center p-4 items-center gap-4"
          >
            <IconInfoCircle size={isPhone ? 60 : undefined} />
            <Text size="lg">{t("user.personalArea")}</Text>
          </div>
          <QuickLinks />
        </Fragment>
      )}
      <Footer isVisible />
    </Fragment>
  );
}

export default UserProfilePage;
